/**
 * this service is private and meant to be used by ParamBaseDataInputMenuMixin only!
 */

import { SET_VALUE_FROM_PREVIOUS_STEP, SET_TEXT_VALUE } from '../../../../DataInput/DataInputMenu/helpers/data-input-menu.const';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
import { setValueForParamKey, clearDataInputState as clearDataInputStateAction } from '@/store/modules/dataInputMenu/actions';

// helper methods of service

const isValueOfSingularColumnOnCustomTab = (isValueSingularColumn, allowCustomValue) => isValueSingularColumn && allowCustomValue;
const isCustomValueOnSingularColumn = (isValueSingularColumn, allowCustomValue) => !isValueSingularColumn && !allowCustomValue;
const isValueDifferentBetweenTwoDynamicColumnsFunction = (isValueSingularColumn, allowCustomValue, acceptsSingularValue) =>
	(isValueOfSingularColumnOnCustomTab(isValueSingularColumn, allowCustomValue) ||
		isCustomValueOnSingularColumn(isValueSingularColumn, allowCustomValue)) &&
	acceptsSingularValue;

const setTab = function (value) {
	this.$set(this.$data, '_tab', value);
};

const getHideRealValue = function () {
	/**
	 * if were switching between ThisFlow & Column tab, when param expects to get single column param,
	 * Column tab acts differently then ThisFlow tab
	 */
	const hideValueBetweenTwoDynamicTabs = isValueDifferentBetweenTwoDynamicColumns.call(this);

	return (this.isValueConstant && !this.curTab?.isConst) || hideValueBetweenTwoDynamicTabs;
};

// methods exported by service

const decideCurrentTab = function () {
	let tab = 0;
	const localValue = this.getParamForNode(this.param.key); // we get the localValue as defined in the getter, so we have the real sourceValue and not the computed one
	const valueFromConstantTab = !!this.param.disable_mapped_data;
	if (this.$data._tabItems.length > 1 && !isNullOrUndefinedOrEmpty(localValue)) {
		// find the first tab that answer the constant condition
		// Being used now when we have 2 tabs, and we have one Constant tab top
		// in the future we should find better way to decide which tab to show - maybe save for each parameter which tab it came from?
		// tab = this.$data._tabItems.findIndex((tab) => (this.isValueConstant ? tab.isConst : !tab.isConst));
		tab = this.$data._tabItems.findIndex((tab) => {
			if (this.isValueConstant || valueFromConstantTab) {
				return tab.isConst;
			} else {
				if (this.isValueSingularColumn) {
					return !tab.isConst && !tab.custom;
				}
				if (this.acceptsSingularValue) {
					return !tab.isConst && tab.custom;
				}
				return !tab.isConst;
			}
			// return this.isValueConstant ? tab.isConst : !tab.isConst;
		});
	}
	setTab.call(this, tab);
};

const setDataInputStateValue = function (key, value) {
	this[setValueForParamKey.fullPath]({ paramKey: this.param.dataInputKey || this.param.key, key, value });
};

const clearDataInputState = function () {
	this[clearDataInputStateAction.fullPath]({ paramKey: this.param.dataInputKey || this.param.key });
};

const addDataInputMenuListeners = function () {
	const listeners = {
		[SET_VALUE_FROM_PREVIOUS_STEP]: this.updateValueFromMenu,
		[SET_TEXT_VALUE]: this.updateValueFromMenu,
		'close-menu': this.closeDataInputMenu,
		'update:tab': (val) => {
			setTab.call(this, val);
		},
	};
	Object.entries(listeners).forEach(([key, method]) => this.addDataInputMenuListener(key, method));
};

const setDataInputMenuProps = function () {
	Object.entries(this.dataInputMenuProps).forEach(([key, value]) => {
		// PERFORMANCE_OPTIMIZATION - setTimeout causes the execution to be async splitting a
		// 'Long Task' into multiple 'Short Tasks' which allows the UI to be responsive to user input
		setTimeout(() => {
			this.setDataInputMenuProp(key, value);
		});
	});
};

const isValueDifferentBetweenTwoDynamicColumns = function () {
	return isValueDifferentBetweenTwoDynamicColumnsFunction(this.isValueSingularColumn, this.allowCustomValue, this.acceptsSingularValue);
};

const addHideRealValueCallback = function () {
	this.addHideRealValueCallback(getHideRealValue.bind(this));
};

const addSetLocalValueBeforeMiddleware = function () {
	const middleware = function () {
		if (!this.curTab.isConst) {
			this.localValueDisplay = '';
		}
	};
	this.addSetLocalValueBeforeMiddleware(middleware.bind(this));
};

const ParamBaseDataInputMenuMixinService = {
	decideCurrentTab,
	setDataInputStateValue,
	clearDataInputState,
	addDataInputMenuListeners,
	setDataInputMenuProps,
	isValueDifferentBetweenTwoDynamicColumns,
	addHideRealValueCallback,
	addSetLocalValueBeforeMiddleware,
};

export default ParamBaseDataInputMenuMixinService;
